import { memo, FC} from "react"

export const Home:FC = memo(() => {
  return (
    <p>Home page</p>
  )
})
